import React from 'react'
import '../App.css'

function Model() {
  return (
    <div className = "model">
      
    </div>
  )
}

export default Model
